import { log } from "@/composables/useLog"
import { BASE_URL } from "@/composables/url_config"
import axios from "axios"

const getHeaders = (token) => ({
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "Accept": "application/json"
})

export const getComments = async (token, options = {}) => {
    log("welcome in getComments")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const params = {}
        if (options.comment_type_id) params.comment_type_id = options.comment_type_id
        if (options.element_id) params.element_id = options.element_id
        if (options.search_term) params.search_term = options.search_term
        if (options.date_from) params.date_from = options.date_from
        if (options.date_to) params.date_to = options.date_to
        if (options.page) params.page = options.page
        if (options.per_page) params.per_page = options.per_page

        const result = await axios.get(BASE_URL + '/home/getCommentsApi', {
            headers: getHeaders(token),
            params
        })
        return result.data
    } catch (err) {
        log("Error in getComments", err)
        return { error: true, message: "Error loading comments" }
    }
}

export const getCommentDetails = async (token, commentId) => {
    log("welcome in getCommentDetails")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getCommentDetailsApi', {
            headers: getHeaders(token),
            params: { comment_id: commentId }
        })
        return result.data
    } catch (err) {
        log("Error in getCommentDetails", err)
        return { error: true, message: "Error loading comment details" }
    }
}

export const getCommentTypes = async (token) => {
    log("welcome in getCommentTypes")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getCommentTypesApi', {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in getCommentTypes", err)
        return { error: true, message: "Error loading comment types" }
    }
}

export const getCommentFilters = async (token) => {
    log("welcome in getCommentFilters")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getCommentFiltersApi', {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in getCommentFilters", err)
        return { error: true, message: "Error loading comment filters" }
    }
}

export const searchElementsForComment = async (token, commentTypeId, searchTerm = '') => {
    log("welcome in searchElementsForComment")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const params = { comment_type_id: commentTypeId }
        if (searchTerm) params.search_term = searchTerm

        const result = await axios.get(BASE_URL + '/home/searchElementsForCommentApi', {
            headers: getHeaders(token),
            params
        })
        return result.data
    } catch (err) {
        log("Error in searchElementsForComment", err)
        return { error: true, message: "Error searching elements" }
    }
}

export const getCommentsCount = async (token, commentTypeId, elementId) => {
    log("welcome in getCommentsCount")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getCommentsCountApi', {
            headers: getHeaders(token),
            params: { comment_type_id: commentTypeId, element_id: elementId }
        })
        return result.data
    } catch (err) {
        log("Error in getCommentsCount", err)
        return { error: true, message: "Error loading comments count" }
    }
}

export const createComment = async (token, data) => {
    log("welcome in createComment")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/createCommentApi', data, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in createComment", err)
        return { error: true, message: "Error creating comment" }
    }
}

export const updateComment = async (token, data) => {
    log("welcome in updateComment")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.put(BASE_URL + '/home/updateCommentApi', data, {
            headers: getHeaders(token)
        })
        return result.data
    } catch (err) {
        log("Error in updateComment", err)
        return { error: true, message: "Error updating comment" }
    }
}

export const deleteComment = async (token, commentId) => {
    log("welcome in deleteComment")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.delete(BASE_URL + '/home/deleteCommentApi', {
            headers: getHeaders(token),
            params: { comment_id: commentId }
        })
        return result.data
    } catch (err) {
        log("Error in deleteComment", err)
        return { error: true, message: "Error deleting comment" }
    }
}

export default {
    getComments,
    getCommentDetails,
    getCommentTypes,
    getCommentFilters,
    searchElementsForComment,
    getCommentsCount,
    createComment,
    updateComment,
    deleteComment
}
